"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title"],
  _excluded2 = ["aria-hidden"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.05 8A6.958 6.958 0 0 1 8 1.05 6.958 6.958 0 0 1 14.95 8 6.958 6.958 0 0 1 8 14.95 6.957 6.957 0 0 1 1.05 8Zm-1 0c0 4.384 3.566 7.95 7.95 7.95 4.383 0 7.95-3.566 7.95-7.95S12.383.05 8 .05C3.616.05.05 3.616.05 8Zm7.783-3.26a.811.811 0 1 0 .001-1.622.811.811 0 0 0-.001 1.622ZM7.5 11.69V7.012H6.258v-1H8a.5.5 0 0 1 .5.5v5.178h1.39v1H6.109v-1H7.5Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.125 11.947c0-5.913 4.811-10.725 10.725-10.725s10.725 4.812 10.725 10.725c0 5.914-4.811 10.725-10.725 10.725S1.125 17.862 1.125 11.947Zm-1.125 0c0 6.534 5.316 11.85 11.85 11.85s11.85-5.316 11.85-11.85S18.384.097 11.85.097 0 5.413 0 11.947ZM11.596 7.01a1.231 1.231 0 1 0 0-2.462 1.231 1.231 0 0 0 0 2.462Zm-.309 10.724v-7.477h-1.88V9.132h2.443c.31 0 .563.252.563.562v8.04h2.106v1.125H9.18v-1.125h2.107Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 15.93c0-7.885 6.415-14.3 14.3-14.3 7.885 0 14.3 6.415 14.3 14.3 0 7.885-6.415 14.3-14.3 14.3-7.885 0-14.3-6.415-14.3-14.3Zm-1.5 0c0 8.712 7.088 15.8 15.8 15.8s15.8-7.088 15.8-15.8S24.512.13 15.8.13 0 7.218 0 15.93Zm15.462-6.584a1.641 1.641 0 1 0-.001-3.283 1.641 1.641 0 0 0 0 3.283Zm-.412 14.3v-9.97h-2.508v-1.5H15.8a.75.75 0 0 1 .75.75v10.72h2.808v1.5h-7.117v-1.5h2.809Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.95 24C1.95 11.842 11.842 1.95 24 1.95c12.158 0 22.05 9.892 22.05 22.05 0 12.158-9.892 22.05-22.05 22.05-12.158 0-22.05-9.892-22.05-22.05ZM.075 24C.075 37.193 10.807 47.925 24 47.925c13.192 0 23.925-10.732 23.925-23.925C47.925 10.808 37.192.075 24 .075 10.807.075.075 10.808.075 24Zm23.41-10.057a2.506 2.506 0 1 0-.002-5.012 2.506 2.506 0 0 0 .001 5.012Zm-.423 22.05V20.348h-3.83v-1.875H24c.517 0 .937.42.937.938v16.582h4.29v1.875H18.773v-1.875h4.29Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.6 32C2.6 15.79 15.789 2.6 32 2.6c16.21 0 29.4 13.19 29.4 29.4 0 16.211-13.19 29.4-29.4 29.4C15.789 61.4 2.6 48.211 2.6 32ZM.1 32C.1 49.59 14.41 63.9 32 63.9c17.59 0 31.9-14.31 31.9-31.9C63.9 14.41 49.59.1 32 .1 14.41.1.1 14.41.1 32Zm31.212-13.409a3.341 3.341 0 1 0 0-6.683 3.341 3.341 0 0 0 0 6.683Zm-.562 29.4v-20.86h-5.107v-2.5H32c.69 0 1.25.56 1.25 1.25v22.11h5.72v2.5H25.029v-2.5h5.72Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconInfo = function IconInfo(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    title = _ref.title,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _props$ariaHidden = props["aria-hidden"],
    ariaHidden = _props$ariaHidden === void 0 ? 'true' : _props$ariaHidden,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  var finalAriaHidden = (title ? false : ariaHidden).toString();
  var finalTitle = finalAriaHidden === 'false' ? title || 'Info' : null;
  if (title && (ariaHidden === true || ariaHidden === 'true') && process.env.NODE_ENV !== 'production') {
    console.warn('Passing a custom title will set the aria-hidden attribute to false within IconInfo. Consider passing aria-hidden="false" explicitly to IconInfo for compatibility with future versions.');
  }
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: finalTitle,
    "aria-hidden": finalAriaHidden
  }, rest, {
    iconClass: "Info"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconInfo.sizes = [16, 24, 32, 48, 64];
IconInfo.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = exports.default = IconInfo;